type ModuleFieldType = 'string' | 'boolean' | 'number';

interface ModuleFieldOverride {
    name: string;
    type: ModuleFieldType;
}

type ModuleOverrides = Record<string, ReadonlyArray<ModuleFieldOverride>>;

const WORKSPACE_MODULE_FIELD_OVERRIDES: ModuleOverrides = {
    MY_FLEET_MODULE: [
        { name: 'canAssignDriversOnBatch', type: 'boolean' },
    ],
} as const;

export default WORKSPACE_MODULE_FIELD_OVERRIDES;
